// extracted by mini-css-extract-plugin
module.exports = {"scoreReportStatusCard":"style-module__scoreReportStatusCard___1z7kq"};